/* eslint eqeqeq: "off" */
import * as React from 'react';
import { connect } from 'react-redux';
import { Card, Accordion } from 'react-bootstrap';

class ClaimFAQ extends React.Component<any, any>  {
    constructor(props) {
        super(props)
        this.state = {
            accordian0Open: false,
        }
        this.handleAccordianArrow = this.handleAccordianArrow.bind(this);
    }

    handleAccordianArrow() {
        if (this.state.accordian0Open) {
            this.setState({ accordian0Open: false });
        }
        else {
            this.setState({ accordian0Open: true });
        }
    }

    public render() {
        return (
            <>
                {this.props.claimSubmit.selectedClaimStep.step === 7 &&
                    <div className='content-box-padding-20px-bottom-40px mt-20px'>
                        <h3>FAQs</h3>
                        < div id="policeReportFAQ" className="new-ssp-faq-block " >
                            <Accordion>
                                <Card>
                                    <Accordion.Toggle as={Card.Header} eventKey="0" onClick={() => this.handleAccordianArrow()}>
                                        <div className="row align-items-center">
                                            <div className="col">
                                                I don&apos;t have a police report number at the moment&#46;&#46;&#46; What should I do?
                                                        </div>
                                            <div className={"accordion-arrow-svg" + (this.state.eventKey0Open ? ' isRotatednew' : '')}></div>
                                        </div>
                                    </Accordion.Toggle>
                                    <Accordion.Collapse eventKey="0">
                                        <Card.Body>
                                            <div className="form-group noma">
                                                <p className="form-control-plaintext">Please report the incident immediately (check out the 'please note' above for more info) and give us the report number.</p>
                                            </div>
                                        </Card.Body>
                                    </Accordion.Collapse>
                                </Card>
                            </Accordion>
                        </div >
                    </div >
                }
                {this.props.claimSubmit.selectedClaimStep.step === 9 &&
                    <div className='content-box-padding-20px-bottom-40px mt-20px'>
                        <h3>FAQs</h3>
                        < div id="comfirmCarDetailsFAQ" className="new-ssp-faq-block " >
                            <Accordion>
                                <Card>
                                    <Accordion.Toggle as={Card.Header} eventKey="0" onClick={() => this.handleAccordianArrow()}>
                                        <div className="row align-items-center">
                                            <div className="col">
                                                Why do I need to confirm this info?
                                            </div>
                                            <div className={"accordion-arrow-svg" + (this.state.eventKey0Open ? ' isRotatednew' : '')}></div>
                                        </div>
                                    </Accordion.Toggle>
                                    <Accordion.Collapse eventKey="0">
                                        <Card.Body>
                                            <div className="form-group noma">
                                                <p className="form-control-plaintext">This info needs to be confirmed to ensure that our assessor assesses the correct car, and to make sure that you're happy with all the info you've submitted so far.</p>
                                            </div>
                                        </Card.Body>
                                    </Accordion.Collapse>
                                </Card>
                            </Accordion>
                        </div >
                    </div >
                }

                {(this.props.claimSubmit.selectedClaimStep.step === 10 && this.props.claimSubmit.selectedClaimStep.subStep === 1) &&
                    <div className='content-box-padding-20px-bottom-40px mt-20px'>
                        <h3>FAQs</h3>
                        < div id="comfirmCarDetailsFAQ" className="new-ssp-faq-block " >
                            <Accordion>
                                <Card>
                                    <Accordion.Toggle as={Card.Header} eventKey="0" onClick={() => this.handleAccordianArrow()}>
                                        <div className="row align-items-center">
                                            <div className="col">
                                                What should I do if the incident wasn’t my fault?
                                            </div>
                                            <div className={"accordion-arrow-svg" + (this.state.eventKey0Open ? ' isRotatednew' : '')}></div>
                                        </div>
                                    </Accordion.Toggle>
                                    <Accordion.Collapse eventKey="0">
                                        <Card.Body>
                                            <div className="form-group noma">
                                                <p className="form-control-plaintext">If you want to claim from King Price, you’ll need to pay the relevant excess amounts when your claim’s authorised. Our legal team will then try to recover the costs from the other party or their insurer (if they’re insured). If our team manages to recover these costs, we’ll refund your excess.</p>
                                                <p className="form-control-plaintext">Alternatively, you can claim directly from the other party/their insurer.</p>
                                            </div>
                                        </Card.Body>
                                    </Accordion.Collapse>
                                </Card>
                            </Accordion>
                        </div >
                    </div >
                }
            </>
        );
    }
}

const mapStateToProps = (state: any) => {
    return {
        claimSubmit: state.claimSubmit,
    }
}

const mapDispatchToProps = (dispatch: any) => {
    return {
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(ClaimFAQ)